export enum SidebarColumn {
  Menu = -1,
  Back = -2,
}
